import cssGlobal from '../../../utils/cssGlobal';
import constants from '../../../constants/styles';
import 'primereact/components/common/Common.css';
import 'primereact/components/dropdown/Dropdown.css';
const {
  BASE_FONT_FAMILY,
  HIGHLIGHT_COLOR,
  PLACEHOLDER_COLOR,
  DISABLED_COLOR,
  DISABLED_BG_COLOR,
  SELECT_BG_COLOR,
  SELECT_ITEM_BG_COLOR,
  SELECT_ITEM_HOVER,
  SELECT_BORDER_COLOR,
  SELECT_ITEM_TEXT_SELECTED_COLOR,
  SELECT_ITEM_TEXT_COLOR,
  SELECT_ITEM_BORDER_COLOR
} = constants;

export default cssGlobal({
  '.ui-dropdown': {
    fontSize: '1em',
    fontFamily: BASE_FONT_FAMILY,
    width: '100%',
    backgroundColor: SELECT_BG_COLOR,
    border: `1px solid ${HIGHLIGHT_COLOR}`,
    borderRadius: 4
  },
  '.ui-dropdown .ui-placeholder': {
    color: PLACEHOLDER_COLOR
  },
  '.ui-dropdown .ui-dropdown-trigger': {
    border: 'none',
    lineHeight: '40px',
    width: '30px',
    fontSize: '16px',
    color: HIGHLIGHT_COLOR
  },
  '.ui-dropdown .ui-dropdown-label': {
    height: '40px',
    padding: 12,
    paddingRight: 36,
    boxSizing: 'border-box',
    whiteSpace: 'nowrap'
  },
  '.ui-dropdown .ui-dropdown-panel': {
    border: `1px solid ${SELECT_BORDER_COLOR}`,
    background: 'white',
    marginTop: -2,
    borderRadius: '0 0 4px 4px',
    paddingLeft: 0,
    paddingRight: 0
  },
  '.ui-dropdown-panel .ui-dropdown-items': {
    padding: 0,
    fontFamily: BASE_FONT_FAMILY
  },
  '.ui-dropdown-panel .ui-dropdown-item': {
    textTransform: 'capitalize',
    backgroundColor: SELECT_ITEM_BG_COLOR,
    color: SELECT_ITEM_TEXT_COLOR,
    padding: '10px 10px',
    borderBottom: `1px solid ${SELECT_ITEM_BORDER_COLOR}`,
    ':hover': {
      backgroundColor: SELECT_ITEM_HOVER,
      color: SELECT_ITEM_TEXT_SELECTED_COLOR
    }
  },
  '.ui-dropdown.ui-state-disabled': {
    opacity: 1
  },
  '.ui-dropdown.ui-state-disabled .ui-dropdown-label': {
    backgroundColor: DISABLED_BG_COLOR,
    color: DISABLED_COLOR
  },
  '.ui-dropdown.ui-state-disabled .ui-dropdown-trigger': {
    backgroundColor: DISABLED_BG_COLOR,
    color: DISABLED_COLOR
  }
});



// WEBPACK FOOTER //
// ./src/components/inputs/select/Select.styles.js